var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-array/src/array.js
// module id = ../../../../d3-array/src/array.js
// module chunks = 4